// @ts-nocheck
/* eslint-disable */
import { getCategories } from "./categories";
import { createCategory } from "./dom";
import { store } from "~/state/store";
import { watch, watchCurrentUser } from "~/state/util";
import { logFixedCategories } from "./analytics";
import { getHistory, saveHistory, removeHistory, removeHistoryItem, enrichHistoryWithDescription } from "~/util/providers/history";
import { node, icon, text } from "~/util/dom";
import MyMapsPopup from "~/es6/mymaps.popup";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import { ROUTE_CONST } from "~/route/const";
import { description } from "~/util/providers/poiagg";

export default class FixedSuggest {
	// onSearch
	constructor(optsArgs) {
		this._opts = Object.assign({
			detailSuggest: false,
			// data { title, query, fromTips, cat }
			onSearch: data => {}
		}, optsArgs);
		this._sc = [];
		this._formNodes = {
			form:null,
			input:null
		};
		this._isOpen = false;
		this._dom = {
			container: node("div", { id:"fixed-suggest" }),
			mainPanel: node("div", { className: "main-panel" }),
			historyPart: null
		};
		this._dom.container.appendChild(this._dom.mainPanel);
		this._data = {};

		this._popup = null;

		const w = watch(store.getState, "user", watchCurrentUser);
		this._storeUnsubscribe = store.subscribe(w(() => {
			this._loginLogout();
		}));
	}

	destructor() {
		this._formNodes = {
			form: null,
			input: null
		};

		this._storeUnsubscribe();
	}

	build() {
		this._setDefault();
	}

	getContainer() {
		return this._dom.container;
	}

	isOpen() {
		return this._isOpen;
	}

	open() {
		if (this._isOpen) return;

		let form  = this._formNodes.form;
		this._setDefault();
		form.appendChild(this._dom.container);
		this._isOpen = true;
		if (Mapy.active[0] === Mapy.getComponent("search")) {
			Mapy.getComponent("layout").getScrollNode().classList.add("fixed-suggest");
		}
	}

	close() {
		if (!this._isOpen) return;

		if(this._dom.container.parentNode == this._formNodes.form) {
			this._dom.container.remove();
			this._formNodes.input.removeEventListener("focus", this, false);
			this._formNodes.input.removeEventListener("blur", this, false);
		}
		this._isOpen = false;
		Mapy.getComponent("layout").getScrollNode().classList.remove("fixed-suggest");
	}

	setFormNodes(form,input) {
		this._formNodes = {
			form:form,
			input:input
		}
	}

	handleEvent(e) {
		if (e.type == "click" && this._popup && !this._popup.contains(e.target)) {
			this._removeResponsivePopup();
		}
	};

	_afterRemoveAll() {
		this._dom.mainPanel.innerHTML = "";
		this._dom.mainPanel.classList.remove("full");
		this._dom.mainPanel.setAttribute("data-type", "");

		let historyPart = node("div", { className: "history" });
		let categoryPart = node("div", { className: "category" });
		let loginPart = node("div", { className: "login" });
		const { user } = store.getState().user;

		if (user.state === "green") {
			let header = node("div", { className: "header" });
			let rightPart = node("span", { className: "right-part" });
			header.appendChild(rightPart);
			historyPart.appendChild(header);
			let content = node("div", { className: "content" });
			historyPart.appendChild(content);

			this._data.history = [];

			let p = node("p", { className: "empty", textContent: _("fixedSuggest.history.empty") });
			content.appendChild(p);
		}

		this._buildCategory(categoryPart);
		this._buildLogin(loginPart);

		this._dom.mainPanel.appendChild(historyPart);
		this._dom.mainPanel.appendChild(categoryPart);
		this._dom.mainPanel.appendChild(loginPart);
		this._dom.historyPart = historyPart;
	}

	_setDefault() {
		this._dom.mainPanel.innerHTML = "";
		this._dom.mainPanel.classList.remove("full");
		this._dom.mainPanel.setAttribute("data-type", "");

		let historyPart = node("div", { className: "history" });
		let categoryPart = node("div", { className: "category" });
		let loginPart = node("div", { className: "login" });

		this._buildHistory(historyPart);
		this._buildCategory(categoryPart);
		this._buildLogin(loginPart);

		this._dom.mainPanel.appendChild(historyPart);
		this._dom.mainPanel.appendChild(categoryPart);
		this._dom.mainPanel.appendChild(loginPart);
		this._dom.historyPart = historyPart;
	}

	_setHistory() {
		this._dom.mainPanel.innerHTML = "";
		this._dom.mainPanel.classList.add("full");
		this._dom.mainPanel.setAttribute("data-type", "");

		let historyPart = node("div", { className: "history" });

		this._buildHistory(historyPart, true);

		this._dom.mainPanel.appendChild(historyPart);
		this._dom.historyPart = historyPart;
	}

	_setCategory() {
		this._dom.mainPanel.innerHTML = "";
		this._dom.mainPanel.classList.add("full");
		this._dom.mainPanel.setAttribute("data-type", "");

		let categoryPart = node("div", { className: "category" });

		this._buildCategory(categoryPart, true);

		this._dom.mainPanel.appendChild(categoryPart);
	}

	_loginLogout() {
		this._setDefault();
	}

	_buildHistory(el, full) {
		el.innerHTML = "";

		const { user } = store.getState().user;

		// Backend nestiha, proto 200ms timeout, jinak by se nam vracel neupravenej list po smazani polozky, nebo pridani
		window.setTimeout(() => {
			getHistory(user, {
				limit: full ? 50 : 3,
				lang: CONFIG.langPriority,
			}).then(async data => {
				if (user.state === "green") {
					let results = await enrichHistoryWithDescription(data?.data?.items || []);
					let len = results.length;
					let header = node("div", { className: "header" });
					let rightPart = node("span", { className: "right-part" });

					if (len) {
						let title = node("h3", { textContent: _("fixedSuggest.history.title") });
						header.appendChild(title);
					}

					header.appendChild(rightPart);
					el.appendChild(header);
					let content = node("div", { className: "content" });
					el.appendChild(content);

					this._data.history = results;

					if (full) {
						let dataType = "";

						if (len == 1) {
							dataType = "type-1";
						}
						else if (len == 2) {
							dataType = "type-2";
						}
						else if (len > 2 && len < 7) {
							dataType = "type-3";
						}
						else {
							dataType = "type-4";
						}

						this._dom.mainPanel.setAttribute("data-type", dataType);
					}

					if (len) {
						if (full) {
							let clearHistoryLink = node("a", { href: "#", textContent: _("fixedSuggest.history.delete"), className: "delete-history" });
							clearHistoryLink.addEventListener("click", e => {
								e.stopPropagation();
								e.preventDefault();

								Mapy.getComponent("logger").log("click", {
									text: "search_history_delete"
								});

								let popup = new MyMapsPopup({
									name: "suggest",
									cb: data => {
										if (data.name == "close") {
											popup.destroy();
										}
									}
								});
								let cont = popup.getContainer()
								let title = node("h4", {}, _("fixedSuggest.history.confirm"));
								let buttons = node("div", { className: "buttons" });
								let confirmBtn = node("button", { button: "button", className: "confirm" }, _("delete"));
								let cancelBtn = node("button", { button: "button", className: "cancel" }, _("cancel"));

								cancelBtn.addEventListener("click", () => {
									Mapy.getComponent("logger").log("click", {
										text: "search_history_delete_no"
									});

									popup.close();
								});

								confirmBtn.addEventListener("click", () => {
									Mapy.getComponent("logger").log("click", {
										text: "search_history_delete_yes"
									});
									// smazeme vse
									removeHistory(user).then(() => {
										this._afterRemoveAll();
									}, () => {});

									popup.close();
								});

								buttons.appendChild(confirmBtn);
								buttons.appendChild(cancelBtn);

								cont.appendChild(title);
								cont.appendChild(buttons);

								popup.open();
							});
							rightPart.appendChild(clearHistoryLink);
							rightPart.appendChild(text(" | "));
						}

						let link = node("a", { href: "#", textContent: full ? _("close") : _("fixedSuggest.history.whole") });
						link.addEventListener("click", e => {
							e.stopPropagation();
							e.preventDefault();

							if (full) {
								this._setDefault();
							}
							else {
								Mapy.getComponent("logger").log("click", {
									text: "search_history_all"
								});

								this._setHistory();
							}
						});
						rightPart.appendChild(link);

						results.slice(0, full ? len : 3).forEach((i, n) => {
							content.appendChild(this._createHistoryItem(i, n, full));
						});
					}
					else {
						if (full) {
							this._setDefault();
						}
						else {
							let p = node("p", { className: "empty", textContent: _("fixedSuggest.history.empty") });
							content.appendChild(p);
						}
					}
				}
			}, e => {});
		}, 200);
	}

	async _buildCategory(el, full) {
		const items = (await getCategories()) || [];
		const categories = items.slice(0, full ? items.length : 4);
		if (categories.length) {
			const moreClick = e => {
				e.preventDefault();
				if (full) {
					Mapy.getComponent("logger").log("click", {
						text: "search_categories_less"
					});
					this._setDefault();
				} else {
					Mapy.getComponent("logger").log("click", {
						text: "search_categories_more"
					});
					this._setCategory();
				}
			};
			const categoryClick = (e, data, index) => {
				if (!Mapy.Util.linkToNewWindow(e)) {
					e.preventDefault();
					this._search([data.title, data.title], 1);
					// analytika - nove logovani sjednocene s appkou
					Mapy.Util.analyticsSearchSelection({
						query: data.title.trim(),
						search_type: "fixed_suggestion",
						result_type: "category",
						index: index + 1,
						name: data.title.trim(),
						target: "search",
					});
				}
			};

			createCategory(el, full, categories, moreClick, categoryClick);
		}
	}

	_createHistoryItem(data, index, full) {
		const href = data.type === "poi"
			? `https://${CONFIG.BASE_URL}/?source=${data.data?.entitySource}&id=${data.data?.entityId}`
			: `https://${CONFIG.BASE_URL}/?q=${encodeURIComponent(data.title)}${data.type === "category" ? "&cat=1" : ""}`;
		const historyLink = node("a", { className: "history-item", href });
		const rightPart = node("span", { className: "right-part" });
		const texts = node("div", { className: "texts" });
		const title = node("span", { className: "title", textContent: data.title });
		const subtitle = node("span", { className: "subtitle", textContent: data.secondRow || "" });
		historyLink.appendChild(icon("history"));
		texts.appendChild(title);
		texts.appendChild(subtitle);
		historyLink.appendChild(texts);
		const hasNavigate = data.data && data.data.entitySource && data.data.entityId;
		let navigateSvg;
		if (hasNavigate) {
			navigateSvg = icon("navigate");
			rightPart.appendChild(navigateSvg);
		}
		let deleteSvg = icon("delete");
		rightPart.appendChild(deleteSvg);
		// pro responziv
		let svgEtc = icon("etc");
		rightPart.appendChild(svgEtc);
		historyLink.appendChild(rightPart);
		let responsive = node("div", { className: "responsive" });
		let responsiveItem;
		if (hasNavigate) {
			responsiveItem = node("p", { className: "responsive-item" });
			responsiveItem.appendChild(icon("navigate"));
			responsiveItem.appendChild(node("span", { textContent: _("seasonPOI.addToRoute") }));
			responsive.appendChild(responsiveItem);
		}
		let responsiveItem2 = node("p", { className: "responsive-item" });
		responsiveItem2.appendChild(icon("delete"));
		responsiveItem2.appendChild(node("span", { textContent: _("delete") }));
		responsive.appendChild(responsiveItem2);
		historyLink.addEventListener("click", e => {
			if (!Mapy.Util.linkToNewWindow(e)) {
				e.stopPropagation();
				e.preventDefault();

				if ((navigateSvg && navigateSvg.contains(e.target)) || (responsiveItem && responsiveItem.contains(e.target))) {
					Mapy.getComponent("logger").log("click", {
						text: "search_history_item_route",
					});
					Mapy.Util.analyticsSearchSelection({
						query: "",
						result_type: "poi",
						search_type: "fixed_suggestion",
						search_purpose: this._opts.detailSuggest ? "detail" : "search",
						poi_id: data.data.entityId,
						poi_title: data.title,
						poi_source: data.data.entitySource,
						target: "route",
					});
					this._removeResponsivePopup();

					description([{ source: data.data.entitySource, id: data.data.entityId, }]).then(async reqData => {
						let descriptionData = reqData.poi && reqData.poi.length ? reqData.poi[0] : null;

						if (descriptionData) {
							let d = descriptionData;
							await Mapy.getComponent("route").addItem(Object.assign({}, d, { desc: d.multiTitle ? d.multiTitle.slice(1).join(", ") : d.title }, { position: ROUTE_CONST.position.end }), true);
							await Mapy.getComponent("route").activate();
							Mapy.getComponent("history").save();
						}
					}, () => {});
				}
				else if (deleteSvg.contains(e.target) || responsiveItem2.contains(e.target)) {
					Mapy.getComponent("logger").log("click", {
						text: "search_history_item_delete"
					});
					this._removeResponsivePopup();
					let itemData = {
						type: data.type,
						title: data.title,
					};

					if (data.type != "category" && data.type != "query") {
						itemData.data = {
							entitySource: data.data.entitySource,
							entityId: data.data.entityId,
							lon: data.data.lon,
							lat: data.data.lat,
						};
					}

					const { user } = store.getState().user;

					removeHistoryItem(user, itemData).then(() => {
						setTimeout(() => {
							this._buildHistory(this._dom.historyPart, full);
						}, 200);
					}, () => {});
				}
				else if (svgEtc.contains(e.target)) {
					if (this._popup) {
						document.removeEventListener("click", this);
						this._popup.remove();
						this._popup = null;
					}

					document.addEventListener("click", this);
					historyLink.appendChild(responsive);
					this._popup = responsive;
				}
				else if (data.type == "poi") {
					if (!Mapy.getComponent("detail").isActive()) {
						logFixedCategories();
					}
					this._openDetail(data, index);
				}
				else if (data.type == "query" || data.type == "category") {
					// analytika
					this._search([data.title, data.title], data.type == "category" ? 1 : 0);
					Mapy.Util.analyticsSearchSelection({
						search_type: "suggestion",
						result_type: data.type == "category" ? "history_category" : "history_query",
						index: index + 1,
						target: "search",
						...data.type == "category" ? { name: data.title } : {},
					});
				}
			}
		});
		return historyLink;
	}

	_buildLogin(el) {
		el.innerHTML = "";
		const { user } = store.getState().user;

		if (user.state !== "green") {
			let link = node("a", { href: "#", textContent: _("fixedSuggest.history.login") });
			link.addEventListener("click", e => {
				e.stopPropagation();
				e.preventDefault();
				Mapy.getComponent("login").open({
					motivation: "none",
				});
			});
			let span = node("span", { textContent: _("fixedSuggest.history.loginDesc2") });
			el.appendChild(link);
			el.appendChild(span);
		}
	}

	_openDetail(data, index) {
		// analytika - nove logovani sjednocene s appkou
		Mapy.Util.analyticsSearchSelection({
			query: data.title.trim().toLowerCase(),
			search_type: "fixed_suggestion",
			result_type: "history_poi",
			index: index + 1,
			poi_id: data.data.entityId,
			poi_source: data.data.entitySource,
			poi_title: data.title.trim(),
			name: data.title.trim()
		});

		Mapy.getComponent("search").clearAll();

		Mapy.getComponent("detail").setState({
			source: data.data.entitySource,
			id: data.data.entityId,
			search: {
				query: data.title,
				hasResults: false
			}
		}).then(() => Mapy.getComponent("history").save(), () => {});

		const { user } = store.getState().user;

		saveHistory(user, {
			title: data.title,
			source: "web",
			type: "poi",
			data: data.data,
		}).then(() => {}, () => {});
	}

	_search(data, cat = 0) {
		this.close();
		// callback
		this._opts.onSearch({
			title: data[0],
			query: data[1],
			fromTips: true,
			cat
		});
	}

	_removeResponsivePopup() {
		if (this._popup) {
			document.removeEventListener("click", this);
			this._popup.remove();
			this._popup = null;
		}
	}
}
